//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { date } from 'quasar'
import { isImageDocument, isVideoDocument } from './FileUtils.js'

export default {
  name: 'FilesFieldTreeNode',
  props: {
    treeNode: {
      type: Object,
      default: null
    },
    file: {
      type: Object,
      required: true
    },
    selectModeEdit: {
      type: Boolean,
      default: false
    },
    mobile: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      expandButtonsVisible: false
    }
  },
  computed: {
    node: function () {
      return this.file._node
    },
    fileDocument: function () {
      return this.file._node._file.document
    },
    fileIcon: function () {
      if (this.file.type === 'folder') {
        return 'mdi-folder-outline'
      } else if (this.fileDocument) {
        if (isImageDocument(this.fileDocument)) {
          return 'mdi-file-image'
        } else if (isVideoDocument(this.fileDocument)) {
          return 'mdi-filmstrip'
        } else {
          return 'mdi-file'
        }
      }
      return 'mdi-file'
    }
  },
  methods: {
    onClick: function (event) {
      this.$emit('click', event)
    },
    onDoubleClick: function (event) {
      if (this.selectModeEdit) {
        this.$emit('dblclick', event)
      }
    },
    onContextMenu: function (event) {
      this.$emit('contextmenu', event)
    },
    getCreationTime: function (fileWrapper) {
      if (fileWrapper.type !== 'folder' && fileWrapper.createTime) {
        return this.formatMillis(fileWrapper.createTime)
      }
      return null
    },
    formatMillis: function (millis) {
      if (millis) {
        return date.formatDate(millis, this.mobile ? 'DD.MM.YYYY HH:mm' : 'DD.MM.YYYY HH:mm:ss')
      }
      return null
    },
    getShortFio: function (fio) {
      const fioArray = fio.split(' ')
      return `${fioArray[0]} ${fioArray.slice(1).map(val => val[0] + '.').join(' ')}`
    }
  }
}
